import React from 'react';
import { Sidebar } from '../../components/shared/Sidebar';
import { DashboardHeader } from '../../components/shared/DashboardHeader';
import { StatCard } from '../../components/shared/StatCard';
import { EmployeeCard } from '../../components/employer/EmployeeCard';
import { MOCK_EMPLOYER, MOCK_AUTHORIZATIONS } from '../../utils/mockData';
import { Users, FileText, CheckCircle, Clock } from 'lucide-react';
import { motion } from 'framer-motion';
export function EmployerDashboard() {
  const pendingAuths = MOCK_AUTHORIZATIONS.filter(a => a.status === 'pending');
  return <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors pb-16 lg:pb-0" data-id="element-3411">
      <Sidebar data-id="element-3412" />

      <main className="flex-1 lg:ml-[240px] transition-all duration-300" data-id="element-3413">
        <DashboardHeader data-id="element-3414" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8" data-id="element-3415">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-3416">
            <div className="mb-6 lg:mb-8" data-id="element-3417">
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white truncate" data-id="element-3418">
                {MOCK_EMPLOYER.companyName}
              </h1>
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 line-clamp-2" data-id="element-3419">
                Manage employee rent deductions and authorizations.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-6 lg:mb-8" data-id="element-3420">
              <StatCard title="Total Employees" value={MOCK_EMPLOYER.employeeCount} icon={Users} color="blue" data-id="element-3421" />
              <StatCard title="Active Deductions" value={MOCK_EMPLOYER.activeDeductions} icon={CheckCircle} color="green" data-id="element-3422" />
              <StatCard title="Pending Requests" value={MOCK_EMPLOYER.pendingRequests} icon={Clock} color="orange" data-id="element-3423" />
              <StatCard title="Total Processed" value="₦12.5M" icon={FileText} color="purple" data-id="element-3424" />
            </div>

            <section data-id="element-3425">
              <div className="flex justify-between items-center mb-4" data-id="element-3426">
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white truncate" data-id="element-3427">
                  Pending Authorizations
                </h2>
                <button className="text-sm text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 font-medium whitespace-nowrap" data-id="element-3428">
                  View All
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6" data-id="element-3429">
                {pendingAuths.map((auth, idx) => <motion.div key={auth.id} initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: idx * 0.05
              }} data-id="element-3430">
                    <EmployeeCard auth={auth} onApprove={id => alert(`Approved ${id}`)} onReject={id => alert(`Rejected ${id}`)} data-id="element-3431" />
                  </motion.div>)}
                {pendingAuths.length === 0 && <div className="col-span-full bg-white dark:bg-gray-800 p-8 rounded-xl border border-gray-200 dark:border-gray-700 text-center text-gray-500 dark:text-gray-400 transition-colors" data-id="element-3432">
                    <CheckCircle className="h-8 w-8 mx-auto mb-2 text-green-500 dark:text-green-400" data-id="element-3433" />
                    <p className="break-words" data-id="element-3434">
                      No pending authorization requests.
                    </p>
                  </div>}
              </div>
            </section>
          </motion.div>
        </div>
      </main>
    </div>;
}